import * as React from "react";

function SvgFacebook(props) {
  return (
    <svg
      width={12}
      height={26}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        opacity={0.597}
        d="M8.006 25.623H3.204V12.811H0V8.396h3.204v-2.6c0-3.601.977-5.793 5.22-5.793h3.534v4.414H9.75c-1.652 0-1.734.62-1.734 1.77l-.006 2.21h3.972l-.469 4.414h-3.5l-.007 12.812z"
        fill="#1b74e4"
      />
    </svg>
  );
}

export default SvgFacebook;
